var getResourceKey = function getResourceKey(component) {
  return function (key) {
    return "costar.component.".concat(component, ".").concat(key);
  };
};
var transferListKey = getResourceKey('transferList');
var resolveCultureText = function resolveCultureText(resolveText) {
  return function (key, def) {
    var _ref;
    return (_ref = resolveText && resolveText(key)) !== null && _ref !== void 0 ? _ref : def;
  };
};
var getResourceTransferListKey = function getResourceTransferListKey(resolveText) {
  return function (key) {
    var def = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return resolveCultureText(resolveText)(transferListKey(key), def);
  };
};

export { getResourceTransferListKey, resolveCultureText };
//# sourceMappingURL=culture-resource-key.esm.js.map
